(function ($) {
    "use strict";


    $(function () {

        window.mobileAndTabletcheck = function () {
            var check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };

        var isIE = /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /Edge\/\d+/.test(navigator.userAgent);
        if (!isIE && $(window).width() > '767') {
            jarallax(document.querySelectorAll('.jarallax'), {

            });
        } else {
            document.body.classList.add('ie');
        }

        objectFitImages();

        $('.js-search-button').on('click', function () {
            $('body').addClass('search-active');
        });

        $('.js-icon-close').on('click', function () {
            $('body').removeClass('search-active');
        });

    

        // my slick slider as constant object
        const testimonialsSlider = $('.js-testimonal').on('init', function (slick) {

            // on init run our multi slide adaptive height function
            multiSlideAdaptiveHeight(this);

        }).on('beforeChange', function (slick, currentSlide, nextSlide) {

            // on beforeChange run our multi slide adaptive height function
            multiSlideAdaptiveHeight(this);

        }).slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            dots: true,
            autoplay: false,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        arrows: false,
                    }
                },
            ]
        });


        // our multi slide adaptive height function passing slider object
        function multiSlideAdaptiveHeight(slider) {

            // set our vars
            let activeSlides = [];
            let tallestSlide = 0;

            // very short delay in order for us get the correct active slides
            setTimeout(function () {

                // loop through each active slide for our current slider
                $('.slick-track .slick-active', slider).each(function (item) {

                    // add current active slide height to our active slides array
                    activeSlides[item] = $(this).outerHeight();

                });

                // for each of the active slides heights
                activeSlides.forEach(function (item) {

                    // if current active slide height is greater than tallest slide height
                    if (item > tallestSlide) {

                        // override tallest slide height to current active slide height
                        tallestSlide = item;

                    }

                });

                // set the current slider slick list height to current active tallest slide height
                $('.slick-list', slider).height(tallestSlide);

            }, 10);

        }


        // when window is resized
        $(window).on('resize', function () {

            // run our multi slide adaptive height function incase current slider active slides change height responsively
            multiSlideAdaptiveHeight(testimonialsSlider);

        });



        $('.js-videos-slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $('.js-videos-paginginfo').text(i + '/' + slick.slideCount);
        });

        $('.js-videos-slider').slick({
            slidesToShow: 3,
            arrows: true,
            prevArrow: $('.js-videos-left'),
            nextArrow: $('.js-videos-right'),
            autoplay: false,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 2,
                        variableWidth: true,

                        infinite: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        variableWidth: true,
                        infinite: false,
                        dots: true,
                    }
                }
            ]
        });


        $('.js-specialist-slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $('.js-specialist-paginginfo').text(i + '/' + slick.slideCount);
        });

        $('.js-specialist-slider').slick({
            slidesToShow: 4,
            arrows: true,
            prevArrow: $('.js-specialist-left'),
            nextArrow: $('.js-specialist-right'),
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 2,
                        variableWidth: true,

                        infinite: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        variableWidth: true,
                        infinite: false,
                        dots: true,
                    }
                }
            ]
        });


        $('.js-article-slider').slick({
            slidesToShow: 3,
            arrows: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: $('.article__card').length - 1,
                        variableWidth: true,
                        dots: true,
                        centerMode: true,
                        centerPadding: '40px',
                        infinite: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                        dots: false,
                        centerMode: false,

                        infinite: false,
                    }

                },

            ]
        });


        $('.js-slider').slick({
            slidesToShow: 1,
            arrows: true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: $('.js-left'),
            nextArrow: $('.js-right'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: false
                    }
                },

            ]
        });


        if (!mobileAndTabletcheck()) {
            if (document.getElementById('scene__1') != null) {
                var scene_1 = document.getElementById('scene__1');
                new Parallax(scene_1);
            }

            if (document.getElementById('scene_treatments') != null) {
                var scene_treatments = document.getElementById('scene_treatments');
                new Parallax(scene_treatments);
            }

            var scene_treatments = document.getElementsByClassName('scene_treatments');

            var scene_treatments_scenes = [];
            for (var i = 0; i < scene_treatments.length; i++) {
                scene_treatments_scenes.push(new Parallax(scene_treatments[i]));
            }

            if (document.getElementById('scene__1_2') != null) {
                var scene__1_2 = document.getElementById('scene__1_2');
                new Parallax(scene__1_2);
            }


            if (document.getElementById('scene__2_1') != null) {
                var scene__2_1 = document.getElementById('scene__2_1');
                new Parallax(scene__2_1);
            }

            if (document.getElementById('scene__2_2') != null) {
                var scene__2_2 = document.getElementById('scene__2_2');
                new Parallax(scene__2_2);
            }

            if (document.getElementById('scene__3') != null) {
                var scene_3 = document.getElementById('scene__3');
                new Parallax(scene_3);
            }


            if (document.getElementById('scene__4') != null) {
                var scene_4 = document.getElementById('scene__4');
                new Parallax(scene_4, {
                    originX: 0,
                });
            }


            if (document.getElementById('scene__6') != null) {
                var scene_6 = document.getElementById('scene__6');
                new Parallax(scene_6);
            }

            if (document.getElementById('scene__7') != null) {
                var scene_7 = document.getElementById('scene__7');
                new Parallax(scene_7);
            }

        }






        $(document).scroll(function () {
            var dHeight = $(this).height() - $(window).height();
            if (dHeight >= $(this).scrollTop()) {
                $('header').addClass('active');
            }

            if ($(this).scrollTop() < 10) {
                $('header').removeClass('active');
            }
        });


    });
})(jQuery);